var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23956 4.0103C7.23956 2.71587 8.28888 1.66655 9.58331 1.66655C10.8777 1.66655 11.9271 2.71587 11.9271 4.0103C11.9271 5.3047 10.8777 6.35405 9.58331 6.35405C8.28888 6.35405 7.23956 5.3047 7.23956 4.0103ZM15.5282 4.05499C15.1214 3.64819 14.4619 3.64819 14.0551 4.05499L11.2352 6.87488H7.93142L5.11153 4.05499C4.70476 3.64819 4.04519 3.64819 3.63842 4.05499C3.23161 4.4618 3.23161 5.12134 3.63842 5.52814L6.71873 8.60841V17.2916C6.71873 17.8668 7.1851 18.3332 7.76039 18.3332H8.28123C8.85652 18.3332 9.3229 17.8668 9.3229 17.2916V13.6457H9.84373V17.2916C9.84373 17.8668 10.3101 18.3332 10.8854 18.3332H11.4062C11.9815 18.3332 12.4479 17.8668 12.4479 17.2916V8.60841L15.5282 5.52811C15.935 5.1213 15.935 4.4618 15.5282 4.05499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChild);
export default __webpack_public_path__ + "static/media/Child.dad0243790a8df47b5a6a2549fb1d4a3.svg";
export { ForwardRef as ReactComponent };